var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"markdown-it-vue-container",staticClass:"markdown-body",on:{"click":_vm.hdlClick}}),(_vm.showViewer)?_c('image-viewer',{attrs:{"url-list":_vm.urlList,"index":_vm.index,"on-close":_vm.closeViewer},on:{"update:index":function($event){_vm.index=$event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }